<template>
  <v-dialog
    @keydown.esc="closeModal"
    v-model="dialog"
    max-width="600px"
    @click:outside="closeModal"
  >
    <v-card>
      <v-card-title>
        {{ $tc('cross_check') }}
        <v-spacer />
        <v-tooltip top>
          <template #activator="{ on }">
            <v-btn icon @click="closeModal()" v-on="on">
              <v-icon>close</v-icon>
            </v-btn>
          </template>
          <span>{{ $tc('close') }} </span>
        </v-tooltip>
      </v-card-title>
      <v-card-text>
        <v-card v-if="loading" flat min-height="200px">
          <v-row align="center" justify="center" class="h-20v">
            <v-progress-circular indeterminate :size="50" />
          </v-row>
        </v-card>
        <v-form v-else-if="items.length" @submit.prevent="submit">
          <template v-for="item in items">
            <div class="monospace font-weight-medium" :key="item.label">
              <v-row>
                <v-col cols="4">
                  {{ item.label }}
                </v-col>

                <v-col cols="4">
                  {{ `${item.peers.length} ${$tc('node', item.peers.length)}` }}
                </v-col>

                <v-col cols="4">
                  <v-tooltip top>
                    <template #activator="{ on }">
                      <v-icon
                        v-on="on"
                        v-if="item.icon"
                        :color="item.iconColor"
                      >
                        {{ item.icon }}
                      </v-icon>
                    </template>
                    <span>{{ item.errorLinkPath ? $tc('error') : $tc('warning') }} </span>
                  </v-tooltip>
                  <template v-if="item.msg">
                    <a
                      v-if="item.errorLinkPath"
                      class="ml-2 text_secondary--text"
                      target="_blank"
                      :href="`https://docs.hsm.dinamonetworks.io/codigos-retorno/hsm_codes_pt_br#${item.errorLinkPath}`"
                    >
                      {{ item.msg }}
                    </a>
                    <span v-else>{{ $tc(item.msg) }}</span>
                  </template>
                </v-col>
              </v-row>
              <div v-if="item.peers.length">
                <v-row class="pl-6" no-gutters v-for="peer in item.peers" :key="peer.id">
                  {{ peer.ip }}
                </v-row>
              </div>
              <v-divider />
            </div>
          </template>
          <v-row no-gutters justify="end" class="mt-4">
            <v-btn
              :loading="nthLoading"
              color="secondary"
              type="submit"
            >
              {{ $t('reload') }}
            </v-btn>
          </v-row>
        </v-form>
        <v-container v-else fluid fill-height>
          <v-row align="center" justify="center">
            <v-col cols="12">
              <p class="text-center font-weight-medium text-h6">
                {{ $t('no_nodes') }}
              </p>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data () {
    return {
      dialog: false,
      nodes: [],
      loading: false,
      nthLoading: false
    }
  },
  computed: {
    maxPeerLen () {
      const peersLenArray = this.nodes.map((node) => { return node.peers.length })
      return Math.max(...peersLenArray)
    },
    items () {
      const items = []
      for (const node of this.nodes) {
        const item = {}
        item.label = node.ip
        item.peers = node.peers
        if (node.rc !== '0x0') {
          const errObj = this.$store.getters['error/getErrorObj']({ rc: parseInt(node.rc, 16) })
          item.msg = node.rc
          item.errorLinkPath = errObj.hint
          item.icon = 'warning'
          item.iconColor = 'red'
        } else if (!this.isMaxPeersLen(node)) {
          item.msg = 'wrong_peers_num'
          item.icon = 'warning'
          item.iconColor = 'orange'
        }
        items.push(item)
      }
      return items
    }
  },
  methods: {
    isMaxPeersLen (node) {
      return node.peers.length === this.maxPeerLen
    },
    closeModal () {
      this.$emit('close')
    },
    firstReportLoad () {
      this.loading = true
      this.getCrossCheck()
        .finally(() => {
          this.loading = false
        })
    },
    submit () {
      this.nthLoading = true
      this.getCrossCheck()
        .finally(() => {
          this.nthLoading = false
        })
    },
    getCrossCheck () {
      return this.$store.dispatch('hsm/getCrossCheck')
        .then(res => {
          this.nodes = res
        })
        .catch(err => {
          const errObj = this.$store.getters['error/getErrorObj'](err)
          if (errObj) {
            this.$notify.hsmError(errObj, err)
          } else {
            this.$notify.error({ message: err })
          }
        })
    },
    clearData () {
      this.nodes = []
    }
  },
  watch: {
    open (val) {
      this.dialog = val
      if (!val) {
        this.clearData()
      } else {
        this.firstReportLoad()
      }
    }
  }
}
</script>
